import React from 'react';

import Page from '../[...all]';

const AboutUs = () => {
  return <Page uri={'about-us'} showBreadcrumbs />;
};

export default AboutUs;
